import exalted from './exalted'
import detriment from './detriment'

export default { exalted, detriment }
